import { ClientChatList } from "@/components/chat/ClientChatList";
import { DashboardHeader } from "@/components/DashboardHeader";
import { DashboardFooter } from "@/components/DashboardFooter";
import { DashboardSidebar } from "@/components/DashboardSidebar";
import { SidebarProvider } from "@/components/ui/sidebar";

const Chat = () => {
  return (
    <div className="dark min-h-screen bg-[#1A1F2C] w-full">
      <SidebarProvider>
        <div className="flex min-h-screen w-full">
          <DashboardSidebar />
          <div className="flex-1">
            <DashboardHeader />
            <main className="flex-1 p-6 mt-16 bg-[#1A1F2C] min-h-screen">
              <div className="max-w-[800px] mx-auto">
                <ClientChatList />
              </div>
            </main>
            <DashboardFooter />
          </div>
        </div>
      </SidebarProvider>
    </div>
  );
};

export default Chat;